import { CLOSE_PROMPT_DIALOG, SHOW_PROMPT_DIALOG } from './constants';

import { IAction } from '@/types/redux';

export interface IShowPromptDialogOptions {
  yesLabel?: string;
  noLabel?: string;
}

export interface IShowPromptDialogAction extends IAction {
  message: string | string[];
  options: IShowPromptDialogOptions;
}

export function showPromptDialog(
  message: string | string[],
  options: IShowPromptDialogOptions,
): IShowPromptDialogAction {
  return {
    type: SHOW_PROMPT_DIALOG,
    message,
    options,
  };
}

/**
 * @param result can be null when user closed dialog with outside click or cross-icon
 * @returns {{type: string, result: (boolean|null)}}
 */
export function closePromptDialog(result: boolean | null) {
  return {
    type: CLOSE_PROMPT_DIALOG,
    result,
  };
}
